import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import TestPage from './components/TestPage';
import ScorePage from './components/ScorePage';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-paper font-body">
        <Header />
        <main className="flex-grow w-full max-w-lg mx-auto px-6 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/score" element={<ScorePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;